"use client";
import React, { useState } from "react";
import { SectionDivider } from "app/components/shared/SectionDivider";
import { Box, Button, Flex } from "@chakra-ui/react";
import CloudHostedTables from "app/pricing/hostedEmulatorsTable/cloudHosted";
import BareMetalTables from "app/pricing/hostedEmulatorsTable/bareMetal";

const CmlPricing = () => {
  const [selectedOption, setSelectedOption] = useState("Cloud Instances");
  const handleClick = (option) => {
    setSelectedOption(option);
  };
  return (
    <Box id="section-pricing" data-cy="section-pricing">
      <SectionDivider label={"Cisco Modelling Lab (CML 2.0) Hosted Service Pricing"} />
      <Flex
        direction={{ base: "column", md: "row" }}
        gap={"15px"}
        justifyContent={"center"}
      >
        <Button
          onClick={() => handleClick("Cloud Instances")}
          width={{ base: "100%", md: "40%" }}
          height={"55px"}
          color={selectedOption === "Cloud Instances" ? "black" : "white"}
          bgColor={selectedOption === "Cloud Instances" ? "#E2E8F0" : "blue.400"}
          _hover={{}}
        >
          <Flex direction={"column"}>
            <Box fontSize={"18px"}>Cloud Instances</Box>
            <Box fontSize={"14px"} fontWeight={"400"}>
              Save 15%(With Annual Billing)
            </Box>
          </Flex>
        </Button>
        <Button
          onClick={() => handleClick("Baremetal")}
          width={{ base: "100%", md: "40%" }}
          height={"55px"}
          color={selectedOption === "Baremetal" ? "black" : "white"}
          bgColor={selectedOption === "Baremetal" ? "#E2E8F0" : "blue.400"}
          _hover={{}}
        >
          <Flex direction={"column"}>
            <Box fontSize={"18px"}>Baremetal</Box>
            <Box fontSize={"14px"} fontWeight={"400"}>
              Save 15%(With Annual Billing)
            </Box>
          </Flex>
        </Button>
      </Flex>
      {selectedOption === "Cloud Instances" && (
        <CloudHostedTables os={["CI-OS-CML2-BYOL"]} />
      )}
      {selectedOption === "Baremetal" && <BareMetalTables os={["BM-OS-CML2-BYOL"]} />}
    </Box>
  );
};
export default CmlPricing;
